import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useEffect, useState } from 'react'

import { IFilter, Operator } from 'core-components/types'
import { Logic } from 'core-components/types/ICrudHelpers'

import { deduplicateProductTreeItems } from '../helpers/deduplicateProductTreeItems'
import { getChildrenByRoot } from '../helpers/getChildrenByRoot'
import { getJbpProductsTreeCrud } from '../helpers/getJbpProductsTreeCrud'
import { mapProductTreeItem } from '../helpers/mapProductTreeItem'
import { IMappedProductTreeItem } from '../models/mappedProductTreeItem'

interface IUseProductTreeItems {
  fYear: number
  root?: string
  partnerType?: string
  programType?: ProgramTypes
}

export const useProductTreeItems = ({
  fYear,
  root,
  partnerType,
  programType,
}: IUseProductTreeItems) => {
  const [productTreeItems, setProductTreeItems] = useState<IMappedProductTreeItem[]>([])

  useEffect(() => {
    const crud = getJbpProductsTreeCrud()

    if (fYear) {
      const filters: IFilter[] = [
        {
          field: 'FYear',
          value: fYear,
          operator: Operator.EQUAL,
        },
      ]
      crud.setSort({
        field: 'order',
        dir: 'asc',
      })

      if (partnerType) {
        filters.push({
          field: 'PartnerType',
          value: partnerType,
          operator: Operator.EQUAL,
        })
      }

      crud.setFilter({
        logic: Logic.AND,
        filters,
      })

      crud.fetch().then((response) => {
        // Remove duplicate parents before traversal, otherwise their descendants repeat too.
        let mappedItems = deduplicateProductTreeItems(response.items).map(mapProductTreeItem)

        if (root) {
          const byRoot = getChildrenByRoot(root, mappedItems)
          if (!byRoot.length && programType) {
            mappedItems = getChildrenByRoot(programType, mappedItems)
          } else {
            mappedItems = byRoot
          }
        }

        setProductTreeItems(mappedItems)
      })
    }
  }, [root, fYear, partnerType, programType])

  return productTreeItems
}
